import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "@/components/ui/drawer";
import { FilteredSidebarMenu } from "./sidebar/FilteredSidebarMenu";
import { AppSidebarHeader } from "./sidebar/SidebarHeader";
import { useIsMobile } from "@/hooks/use-mobile";

export function MobileDrawer() {
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useIsMobile();

  if (!isMobile) return null;

  return (
    <Drawer open={isOpen} onOpenChange={setIsOpen} direction="right">
      <DrawerTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="lg:hidden hover:bg-accent/50 transition-colors"
          aria-label="فتح القائمة"
        >
          <Menu className="h-5 w-5" />
        </Button>
      </DrawerTrigger>
      <DrawerContent 
        className="right-0 left-auto h-full w-[280px] sm:w-80 max-w-[85vw] rounded-l-lg rounded-r-none border-l bg-background shadow-2xl z-[100]"
        dir="rtl"
      >
        <DrawerHeader className="flex items-center justify-between p-4 border-b">
          <DrawerTitle className="text-lg font-semibold">القائمة الرئيسية</DrawerTitle>
          <DrawerClose asChild>
            <Button variant="ghost" size="icon" className="hover:bg-accent/50">
              <X className="h-5 w-5" />
            </Button>
          </DrawerClose>
        </DrawerHeader>
        
        <div className="flex-1 overflow-y-auto p-4">
          <AppSidebarHeader />
          <div className="mt-4">
            <FilteredSidebarMenu />
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
}